import { jsx as _jsx } from "react/jsx-runtime";
import { useTheme } from 'styled-components';
import Div from '../../../common/div';
const BreadcrumbDivider = () => {
    const theme = useTheme();
    return (_jsx(Div, { flex: "row", align: "center", fullHeight: true, children: _jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "5", height: "8", viewBox: "0 0 5 8", fill: "none", children: _jsx("path", { d: "M1 1L4 4L1 7", stroke: theme.colors.grey_2, strokeLinecap: "round", strokeLinejoin: "round" }) }) }));
};
export default BreadcrumbDivider;
